import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Spinner } from "react-bootstrap";
import Button from "presentation/components/Button/Button";
import styles from "presentation/components/OneTrustNotices/OneTrustNotice.module.scss";

declare var OneTrust: any;

type OneTrustNoticeProps = {
    noticeUrl: string;
    noticeId: string;
};

const OneTrustNotice = ({ noticeUrl, noticeId }: OneTrustNoticeProps) => {
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const scriptId = "otprivacy-notice-script";

        if (!document.getElementById(scriptId)) {
            const script = document.createElement("script");
            script.src = "https://privacyportal-cdn.onetrust.com/privacy-notice-scripts/otnotice-1.0.min.js";
            script.async = true;
            script.id = scriptId;


            script.onload = () => {
                if (OneTrust?.NoticeApi?.Initialized?.then) {
                    OneTrust.NoticeApi.Initialized.then(() => {
                        OneTrust.NoticeApi.LoadNotices([noticeUrl]);
                        setTimeout(() => {
                            setIsLoading(false);
                        }, 1500);
                    });
                } else {
                    console.error("OneTrust not available");
                    setIsLoading(false);
                }
            };

            document.body.appendChild(script);
        }

        return () => {
            const existingScript = document.getElementById(scriptId);
            if (existingScript) {
                document.body.removeChild(existingScript);
            }
        };
    }, [noticeUrl]);

    return (

        <div className="d-flex justify-content-center align-items-center w-100">
            {isLoading && (
                <div className="d-flex justify-content-center align-items-center vh-100">
                    <Spinner animation="border" variant="light" />
                </div>
            )}

            <div className={`${styles.popup} px-5 py-4 mb-2 ${isLoading ? "d-none" : ""}`}>
                <div className="otnotice-language-dropdown-container mb-3">
                    <select id="otnotice-language-dropdown" aria-label="language selector" />
                </div>
                <div id={noticeId} className="otnotice" ></div>
                <div className={`${styles.close} float-end mt-3`}>
                    <Button label="OK" onClick={() => navigate("/")} />
                </div>
            </div>

        </div>
    );
};

export default OneTrustNotice;
